module.exports = __webpack_public_path__ + "static/media/TOTAL-SCORE-4.a6a1a8cb.png";